
/**
 * 
 * chaque function renvoie un boolean dépendant du fait que value passe le test ou non
 */
export const sanitizeFunctions = {
    mail: email => {
        var regex = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
        return regex.test(email);
    },
    tel: phone => {
        var regex = new RegExp(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/gim);
        return regex.test(phone);
    },
    shortTxt: v => {
        v = v.trim();
        return v.length > 0 && v.length < 30;
    },
    longTxt: v => {
        v = v.trim();
        return v.length > 1;
    },
    checked: v => v == true,
    unchecked: v => v == false    
}